window.onload = () => {
	email.onmousedown = () => {
		email.href = window["atob"]("bWFpbHRvOmsydHR5Y2F0QGdtYWlsLmNvbQ==");
	}
	email.onmouseleave = () => {
		email.href = "mailto:hell@naw.com";
	}
};